/* eslint-disable react/prop-types */
import React from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
const LeavePieChart = ({ chartOptions }) => {
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={chartOptions}
      style={{ height: '70px', width: '70px' }}
    />
  );
};

export default LeavePieChart;
